module.exports = __webpack_public_path__ + "img/coating_bg.2fd214a8.png";